var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledCaretDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_7816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3841 7.94341L11.1341 14.1934C11.076 14.2515 11.0071 14.2976 10.9312 14.3291C10.8554 14.3605 10.774 14.3767 10.6919 14.3767C10.6098 14.3767 10.5284 14.3605 10.4526 14.3291C10.3767 14.2976 10.3078 14.2515 10.2497 14.1934L3.99971 7.94341C3.9122 7.856 3.8526 7.74459 3.82844 7.62328C3.80429 7.50198 3.81666 7.37624 3.86401 7.26197C3.91135 7.14771 3.99154 7.05006 4.09441 6.98139C4.19728 6.91272 4.31821 6.87612 4.4419 6.87622H16.9419C17.0656 6.87612 17.1865 6.91272 17.2894 6.98139C17.3923 7.05006 17.4724 7.14771 17.5198 7.26197C17.5671 7.37624 17.5795 7.50198 17.5554 7.62328C17.5312 7.74459 17.4716 7.856 17.3841 7.94341Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_7816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.691895 20.0012)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledCaretDown);
export default __webpack_public_path__ + "static/media/filled-caret-down.69f978c97bb753186d0afe8a5f0321e9.svg";
export { ForwardRef as ReactComponent };